var _rect, _g, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatesGoingOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833374,
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 22.6562C10.9709 22.6562 8.86992 21.9284 7.0303 20.4727C5.1907 19.0171 4.00247 17.1407 3.46561 14.8438H5.06012C5.5863 16.7041 6.61261 18.2108 8.13905 19.364C9.66549 20.5172 11.3969 21.0938 13.3334 21.0938C14.9533 21.0938 16.4424 20.6664 17.8005 19.8117C19.1587 18.957 20.2324 17.8218 21.0217 16.4062H17.7605V14.8438H23.4896V20.5729H21.9271V17.8885C20.9576 19.3482 19.722 20.5077 18.2202 21.3671C16.7185 22.2265 15.0895 22.6562 13.3334 22.6562ZM3.17712 10.1562V4.42708H4.73962V7.11141C5.70917 5.65174 6.94482 4.4922 8.44658 3.63281C9.94831 2.77344 11.5773 2.34375 13.3334 2.34375C15.6958 2.34375 17.7969 3.07157 19.6365 4.52721C21.4761 5.98287 22.6643 7.8592 23.2012 10.1562H21.6067C21.0805 8.29589 20.0542 6.78914 18.5277 5.63596C17.0013 4.48279 15.2698 3.9062 13.3334 3.9062C11.7134 3.9062 10.2244 4.33356 8.86621 5.18828C7.50804 6.04299 6.43431 7.17814 5.64504 8.59375H8.90626V10.1562H3.17712Z",
    fill: "#116DC6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11_320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 9,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16675,
    y: 8.33325,
    width: 8.33333,
    height: 8.33333,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3785 15.9723L12.2396 14.8612C12.1644 14.8322 12.0935 14.7975 12.0269 14.757C11.9604 14.7165 11.8953 14.6731 11.8316 14.6268L10.7986 15.0608L9.84375 13.4115L10.7378 12.7344C10.7321 12.6939 10.7292 12.6549 10.7292 12.6172V12.3829C10.7292 12.3453 10.7321 12.3062 10.7378 12.2657L9.84375 11.5886L10.7986 9.93929L11.8316 10.3733C11.8953 10.327 11.9618 10.2836 12.0313 10.2431C12.1007 10.2026 12.1701 10.1679 12.2396 10.1389L12.3785 9.02783H14.2882L14.4271 10.1389C14.5023 10.1679 14.5732 10.2026 14.6398 10.2431C14.7063 10.2836 14.7714 10.327 14.8351 10.3733L15.8681 9.93929L16.8229 11.5886L15.9288 12.2657C15.9346 12.3062 15.9375 12.3453 15.9375 12.3829V12.6172C15.9375 12.6549 15.9317 12.6939 15.9201 12.7344L16.8142 13.4115L15.8594 15.0608L14.8351 14.6268C14.7714 14.6731 14.7049 14.7165 14.6354 14.757C14.566 14.7975 14.4965 14.8322 14.4271 14.8612L14.2882 15.9723H12.3785ZM13.3507 13.7153C13.6863 13.7153 13.9728 13.5967 14.2101 13.3594C14.4473 13.1222 14.566 12.8357 14.566 12.5001C14.566 12.1644 14.4473 11.8779 14.2101 11.6407C13.9728 11.4034 13.6863 11.2848 13.3507 11.2848C13.0093 11.2848 12.7214 11.4034 12.487 11.6407C12.2526 11.8779 12.1354 12.1644 12.1354 12.5001C12.1354 12.8357 12.2526 13.1222 12.487 13.3594C12.7214 13.5967 13.0093 13.7153 13.3507 13.7153Z",
    fill: "#116DC6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesGoingOn);
export default __webpack_public_path__ + "static/media/updates_going_on.a864e2019c5e5dd4e1b79d4b4a99408c.svg";
export { ForwardRef as ReactComponent };